<template>
  <div class="page mx-1">
        <!-- <div class="jumbotron jumbotron-fluid d-flex flex-column justify-content-center"
            :style="{backgroundImage: 'url(' + require('@/assets/img/logo1.png')+')'}">
            <div class="container d-flex flex-column align-items-center">                
                <p class="hero-subtitle">
                    <login/>
                </p>
            </div>
        </div>         -->
        <div class="row py-5 px-3">            
            <div class="col-md-6">
                <div class="card home-card card-hotels justify-content-between align-items-start px-4 py-5">
                    <div class="card-icon">
                        <img :src="require('@/assets/img/logo1.png')" width="100%" />                        
                    </div>
                    <div class="card-text text-white">                        
                        <p>Hartford, SL</p>
                        <p>Empresa Socio-Cultural ...</p>
                    </div>                    
                    <!-- <b-link to="/hoteles" class="btn btn-outline-light">Ver Hoteles</b-link> -->
                    <div class="img-cover card-hotels"></div> 
                </div>
            </div>
            <div class="col-md-6">
                <div class="card home-card card-hotels justify-content-between align-items-start px-4 py-5">
                    <login/>
                </div>
            </div>
        </div>
      
    </div>
</template>

<script>

import login from '@/components/login.vue'

export default {
  name: 'home',
  components: { login,
  },
  data() {
    return {
    }
  },
}
</script>
